import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引用vant组件 懒加载lazyload
import Vant, { Lazyload } from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
Vue.use(Lazyload, {lazyComponent: true});

// request封装
import request from '@/utils/request';
Vue.prototype.$request = request;

// 360设计图自适应
import "./utils/rem.js"

// 集成微信js-sdk
import wx from 'weixin-js-sdk'
Vue.prototype.wx = wx

// 路由全局前置守卫
import "./permission.js"

// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
